<template>
    <div class="planning-default">
        <div class="row d-flex align-items-center justify-content-between">
            <div class="col-12 col-md-auto text-center text-sm-start">
                <page-title
                    v-if="formattedPlanning"
                    :title="this.$moment(date).format('dd D MMM')"
                    icon="planning"
                ></page-title>
                <page-title
                    v-else
                    title="Geen planning"
                    icon="planning"
                ></page-title>
            </div>
            <div class="col-12 col-md-auto text-center text-md-end pb-0">
                <button
                    v-if="showMutationsOnly === true"
                    class="btn btn-secondary me-1"
                    @click="showMutationsOnly = !showMutationsOnly"
                >
                    <i class="fa-solid fa-calendar-circle-exclamation"></i>
                </button>
                <button
                    v-else
                    class="btn btn-secondary me-1"
                    @click="showMutationsOnly = !showMutationsOnly"
                >
                    <i class="fa-light fa-calendar-circle-exclamation"></i>
                </button>
                <date-range-select
                    :listenToDate="this.$moment(date).format('YYYY-MM-DD')"
                    type="day"
                    @changeDateRange="setDate($event.dateStart)"
                    :emitOnCreated="false"
                ></date-range-select>
                <date-picker
                    :listenToDate="this.$moment(date).format('YYYY-MM-DD')"
                    @setDate="setDate($event)"
                    type="button"
                />
            </div>
        </div>
        <div class="row g-2 my-2">
            <div
                v-if="getApplicationSetting('ipad_real_time_bkr') === '0'"
                class="col-6 col-sm-3"
            >
                <span :class="['badge me-1', totalChildrenPresent > 0 ? 'bg-succes' : '']">
                  {{ totalChildrenPresent }}
                </span>
                <span class="d-inline d-sm-block d-md-inline">kinderen aanwezig</span>
            </div>

            <template v-if="formattedPlanning && formattedPlanning.length > 0 && getApplicationSetting('ipad_child_employee_ratio') === '1' && getApplicationSetting('ipad_real_time_bkr') === '1'">
                <div class="col-6 col-sm-3">
                    <span :class="['badge me-1', totalChildrenPresent > 0 ? 'bg-succes' : '']">
                        {{ totalChildrenPresent }}
                    </span>
                    <span class="d-inline d-sm-block d-md-inline">kinderen aanwezig</span>
                </div>
                <div class="col-6 col-sm-3">
                    <span class="badge me-1">{{ Math.max(0, employeesNeeded || 0) }}</span>
                    <span class="d-inline d-sm-block d-md-inline">medewerkers nodig</span>
                </div>
            </template>
            <div
                v-if="getApplicationSetting('ipad_care') === '1' && isAuthorized('instructions', 'index', 'view')"
                class="col-6 col-sm-3"
            >
                <button
                    type="button"
                    class="btn btn-link p-0"
                    @click="showModalCare = true"
                >
                    <span :class="['badge me-1', totalChildrenCare > 0 ? 'bg-danger' : '']">
                        {{ totalChildrenCare }}
                    </span>
                    <span class="d-inline d-sm-block d-md-inline">verzorging</span>
                </button>
            </div>
            <div
                v-if="getApplicationSetting('ipad_transfer_notes') === '1'"
                class="col-6 col-sm-3"
            >
                <button
                    type="button"
                    class="btn btn-link p-0"
                    @click="openTransferNotesDialog('nonSticky')"
                >
                    <span :class="['badge me-1', totalTransferNotesWithDate > 0 ? 'bg-danger' : '']">
                        {{ totalTransferNotesWithDate }}
                    </span>
                    <span class="d-inline d-sm-block d-md-inline">overdracht</span>
                </button>
            </div>

            <div
                v-if="getApplicationSetting('ipad_announcements') === '1'"
                class="col-6 col-sm-3"
            >
                <button
                    type="button"
                    class="btn btn-link p-0"
                    @click="openTransferNotesDialog('sticky')"
                >
                    <span :class="['badge me-1', totalTransferNotesWithoutDate > 0 ? 'bg-danger' : '']">
                        {{ totalTransferNotesWithoutDate }}
                    </span>
                    <span class="d-inline d-sm-block d-md-inline">mededelingen</span>
                </button>
            </div>
        </div>
        <div
            v-if="isLoading"
            class="row"
        >
            <div class="col-12 text-center">
                <p>Laden...</p>
            </div>
        </div>
        <div
            v-else-if="formattedPlanning && formattedPlanning.length > 0 && children && children.length > 0"
            class="mt-2"
        >
            <div
                v-if="getApplicationSetting('ipad_child_employee_ratio') === '1'"
                class="row"
                style="margin-bottom: 2px;"
            >
                <div class="col-12 p-0 d-flex">
                    <div
                        class="d-inline-block"
                        v-for="time in timeLineHours"
                        v-bind:key="time"
                        :style="{width: hourPercentage + '%'}"
                    >
                        {{ time }}
                    </div>
                </div>
            </div>
            <div
                v-if="getApplicationSetting('ipad_child_employee_ratio') === '1'"
                class="row"
                style="margin-bottom: 10px"
            >
                <div class="col-12" style="text-align: left">
                    <child-ratio-bar
                        :date="this.$moment(date).format('YYYY-MM-DD')"
                        :data="planningRatio"
                        :minStartTime="this.startTime"
                        :maxEndTime="this.endTime"
                    />
                </div>
            </div>
            <ChildPlanningRow
                v-for="child in formattedPlanning"
                :key="child.id_child"
                :child-row="child"
                :full-child="getChild(child.id_child) || child"
                :show="!!getChild(child.id_child) || filter.length < 1"
                :age-years="getAgeInYears((getChild(child.id_child) || child).date_of_birth, false)"
                :school="(getChild(child.id_child) || child).school || null"
                :schoolClass="(getChild(child.id_child) || child).schoolClass || null"
                :allow-edit="getApplicationSetting('ipad_planning_row_edit') === '1'"
                :date-resolved="(typeof date !== 'string' ? date.format('YYYY-MM-DD') : date)"
                :current-group-id="getCurrentGroup(getChild(child.id_child) || child)"
                @toggle-presence="togglePresence(child)"
                @open-planning="showModalPlanningAction(child.id_child, $event.currentGroupId, $event.date)"
            />
        </div>
        <div
            v-else
            class="row"
        >
            <div class="col-12 text-center">
                <p>Geen planning</p>
            </div>
        </div>

        <CareOverviewModal
            v-if="showModalCare"
            :childIds="childrenCareUniqueIdChilds"
            @onClose="showModalCare = false"
        />

        <TransferNotesListModal
            v-if="showModalTransferNotes"
            :date="date"
            :transferNotesType="transferNotesType"
            @onClose="showModalTransferNotes = false"
        />

        <modal v-if="showModalPlanning">
            <template v-slot:header>
                <h3 class="modal-title">{{ modalTitle }}</h3>
                <button
                    v-on:click="closeModalPlanningAction()"
                    class="btn-close"
                ></button>
            </template>ƒ
            <template v-slot:body>
                <div
                    id="calendarDialog"
                    class="dialog-child-planning"
                    style="padding: 20px"
                >
                    <agenda-dialog
                        :idChild="modalSelect.idChild"
                        :idGroup="modalSelect.idGroup"
                        :date="modalSelect.date"
                        :agendaDialogsessionToken="session.session_token"
                        :agendaDialogDeviceToken="deviceToken"
                        :agendaDialogApi="apiUrl"
                        :agendaDialogApiV3="apiUrlV3"
                        @agenda-dialog-child-ill="illChanged"
                    />
                </div>
            </template>
            <template v-slot:footer>
                <div>
                    <button
                        type="button"
                        class="btn btn-outline-info"
                        v-on:click="closeModalPlanningAction()"
                    >Sluiten</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
import DatePicker from '@/components/Date-Picker'
import PageTitle from '@/components/Page-Title'
import Modal from '@/components/Modal'
import "@novict/kidsadmin-agenda-dialog/dist/kidsadmin-agenda-dialog.css"
import AgendaDialog from "@novict/kidsadmin-agenda-dialog"
import CareOverviewModal from '@/modals/CareOverviewModal'
import TransferNotesListModal from '@/modals/TransferNotesListModal'
import ChildPlanningRow from '@/components/Child-Planning-Row'
import ChildRatioBar from '@/components/Child-Ratio-Bar'

export default {
    name: 'planning-detailed-list',
    components: {
        DateRangeSelect,
        DatePicker,
        PageTitle,
        Modal,
        AgendaDialog,
        CareOverviewModal,
        TransferNotesListModal,
        ChildPlanningRow,
        ChildRatioBar
    },
    computed: {
        planning() {
            return this.$store.getters.planning
        },
        planningRatio() {
            return this.$store.getters.planningRatio || []
        },
        filter() {
            return this.$store.getters.globalChildByIdFilter
        },
        transferNotes() {
            return this.$store.getters.transferNotes
        },
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
        selectedGroup() {
            return this.$store.getters.selectedGroup
        },
        groupInstructions() {
            return this.$store.getters.groupInstructions
        }
    },
    data() {
        return {
            employeesNeeded: null,
            date: null,
            addNewTransferNote: false,
            showModalCare: false,
            showModalTransferNotes: false,
            showModalPermissions: false,
            totalChildrenPresent: 0,
            totalChildrenCare: 0,
            totalTransferNotesWithDate: 0,
            totalTransferNotesWithoutDate: 0,
            dialogTransferNotes: [],
            care: null,
            showModalPlanning: false,
            modalTitle: "",
            modalSelect: {
                idChild: 0,
                idGroup: 0,
                date: '',
            },
            apiUrl: process.env.VUE_APP_API_URL,
            apiUrlV3: process.env.VUE_APP_API_V3_URL,
            showMutationsOnly: false,
            formattedPlanning: [],
            childrenCareUniqueIdChilds: [],
            startTime: null,
            endTime: null,
            hourPercentage: null,
            timeLineHours: [],
        }
    },
    watch: {
        planning() {
            this.updatePlanning()
        },
        children() {
            this.setTotalChildrenCare()
            this.setTotalChildrenPresent()
            this.updatePlanning()
        },
        transferNotes() {
            this.setTotalTransferNotes()
            this.setTotalAnnouncements()
        },
        groupInstructions() {
            this.setTotalTransferNotes()
            this.setTotalAnnouncements()
        },
        showMutationsOnly() {
            this.updatePlanning()
        }
    },
    created() {
        this.$store.dispatch('getChildren')

        let planDate = this.$moment().format('YYYY-MM-DD');
        if (this.$store.getters.datePlanning !== null) {
            planDate = this.$moment(this.$store.getters.datePlanning).format('YYYY-MM-DD')
        } else {
            if (this.planning && this.planning.date) {
                planDate = this.$moment(this.planning.date).format('YYYY-MM-DD')
            }
        }

        this.setDate(planDate)
        this.setTotalChildrenPresent()
        this.setTotalChildrenCare()
        this.setTotalTransferNotes()
        this.setTotalAnnouncements()

        window.novict = {
            apiBaseUrl: process.env.VUE_APP_API_URL,
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
    },
    methods: {
        updateEmployeesNeeded() {
            if (this.getApplicationSetting('ipad_real_time_bkr') === '0') {
                return
            }
            this.employeesNeeded = null
            this.getBkr(this.date).then((response) => {
                if (response.data.employees_needed) {
                    this.employeesNeeded = response.data.employees_needed
                }
            })
        },
        updatePlanning() {
            let rawPlanning = this.$store.getters.planning
            let planningPerChild = {}
            let childIdsNotInLocalStorage = []
            let startTime = null;
            let endTime = null;
            if (rawPlanning && rawPlanning.length > 0) {
                for (let i = 0; i < rawPlanning.length; i++) {
                    let planItem = rawPlanning[i]

                    if (startTime === null || planItem.start_time < startTime) {
                        startTime = planItem.start_time;
                    }

                    if (endTime === null || planItem.end_time > endTime) {
                        endTime = planItem.end_time;
                    }

                    if (
                        this.showMutationsOnly === true
                        &&
                        rawPlanning[i].status
                        &&
                        rawPlanning[i].status === 'DEFAULT'
                    ) {
                        continue;
                    }
                    if (this.getChildShouldBeVisibleById(planItem.child.id) === false) {
                        continue
                    }
                    if (!Object.prototype.hasOwnProperty.call(planningPerChild, planItem.child.id)) {
                        planningPerChild[planItem.child.id] = {
                            id_child: planItem.child.id,
                            planning: []
                        }
                    }
                    planningPerChild[planItem.child.id].planning.push(planItem)
                    if (this.getChild(planItem.child.id) === false) {
                        childIdsNotInLocalStorage.push(planItem.child.id)
                    }
                }
                if (childIdsNotInLocalStorage.length > 0) {
                    this.appendChildrenById(childIdsNotInLocalStorage)
                }
                this.startTime = this.$moment('2022-01-01 ' + startTime).startOf('hour').format('HH:mm:ss')
                const m = this.$moment('2022-01-01 ' + endTime);
                if (m.minute()) {
                    m.add(1, 'hours')
                }
                endTime = m.startOf('hour').format('HH:mm:ss')
                if (endTime === '00:00:00') {
                    endTime = '23:59:59'
                }
                this.endTime = endTime

                const startTimeInt = parseInt(this.startTime.substr(0, 2))
                let endTimeInt = parseInt(this.endTime.substr(0, 2))
                // fix for care until 23:30 for example, see ticket #58092
                if (parseInt(this.endTime.substr(3, 2)) > 0) {
                    endTimeInt++
                }
                // fix for child care until 00:00, see ticket #57469
                if (endTimeInt === 0) {
                    endTimeInt = 24
                }

                this.hourPercentage = 100 / (endTimeInt - startTimeInt)

                this.timeLineHours = [];
                for (let i = startTimeInt; i < endTimeInt; i++) {
                    this.timeLineHours.push(i);
                }
            }
            planningPerChild = Object.values(planningPerChild)
            planningPerChild = this.sortArrayByChildOrder(planningPerChild, 'id_child')
            this.setIsLoading(false)

            this.formattedPlanning = planningPerChild
            this.setTotalChildrenCare()
            this.setTotalChildrenPresent()
        },
        closeModalPlanningAction() {
            this.showModalPlanning = false
            this.modalTitle = ''
            this.setDate(this.date)
        },
        showModalPlanningAction(idChild, idGroup, date) {
            this.showModalPlanning = true;
            this.modalSelect = {
                idChild: idChild,
                idGroup: idGroup,
                date: date,
            },
                this.$request.post(process.env.VUE_APP_API_URL + "/ChildPlanning/gettitle", {
                    ...this.$request.getDeprecatedBodyAuthentication(),
                    idChild: idChild,
                    date: date
                })
                    .then(data => {
                        this.modalTitle = "Planning " +
                            data.child.name +
                            " op " +
                            this.$moment(data.date).format("DD-MM-YYYY");
                    });
        },
        setIsLoading(bool) {
            this.isLoading = bool
        },
        openTransferNotesDialog(transferNotesType) {
            this.showModalTransferNotes = true
            this.transferNotesType = transferNotesType;
        },
        sort(children, by) {
            by = by || this.getApplicationSetting('ipad_sort_children_by')
            if (by === false) {
                by = 'first_name'
            }
            return this.$lodash().sortBy(children, [child => child[by].toLowerCase()], 'asc')
        },
        setDate(date) {
            this.date = date
            this.setIsLoading(true)
            this.$store.dispatch('getPlanning', this.$moment(date).format('YYYY-MM-DD'))
            this.$store.dispatch('getChildrenPresence')
            this.$store.dispatch('getTransferNotes', {date: this.$moment(date).format('YYYY-MM-DD')})
            this.$store.dispatch('getGroupInstructions')
            this.$store.dispatch('updateDatePlanning', date)
        },
        setTotalChildrenPresent() {
            let total = 0
            let presentChildren = this.getChildrenPresent()
            total = presentChildren.length || 0
            if (this.totalChildrenPresent !== total) {
                this.updateEmployeesNeeded()
                this.totalChildrenPresent = total
            }

        },
        setTotalChildrenCare() {
            let total = 0
            if (this.planning) {
                this.childrenCareUniqueIdChilds = []
                let presentChildren = this.planning
                for (let i = 0; i < presentChildren.length; i++) {
                    if (this.getItemsFilteredByChild({id: presentChildren[i].child.id}, this.groupInstructions).length > 0) {
                        if (this.childrenCareUniqueIdChilds.includes(presentChildren[i].child.id) === false) {
                            this.childrenCareUniqueIdChilds.push(presentChildren[i].child.id)
                            total++
                        }
                    }
                }
            }
            this.totalChildrenCare = total
        },
        setTotalTransferNotes() {
            let total = 0
            if (this.transferNotes) {
                for (let i = 0; i < this.transferNotes.length; i++) {
                    if (this.transferNotes[i].sticky === false && this.transferNotes[i].date === this.date) {
                        total++
                    }
                }
            }
            this.totalTransferNotesWithDate = total
        },
        setTotalAnnouncements() {
            let total = 0
            if (this.transferNotes) {
                for (let i = 0; i < this.transferNotes.length; i++) {
                    if (this.transferNotes[i].sticky === true) {
                        total++
                    }
                }
            }
            this.totalTransferNotesWithoutDate = total
        },
        getChildrenPresent() {
            const app = this
            return this.$lodash().filter(this.children, function (child) {
                return app.getChildIsPresent(child)
            })
        },
        childInPlanning(child) {
            let inPlanning = false
            if (this.planning && this.planning.length > 0) {
                this.planning.forEach(element => {
                    if (element.id_child === child.id) {
                        inPlanning = true
                    }
                })
            }
            return inPlanning
        },
        togglePresence(child) {
          if (!this.isAuthorized('planning', 'presence', 'view')) {
            return;
          }
            child = this.getChild(child.id_child) || child
            if (this.getChildIsPresent(child) === true) {
                // becomes false
                var presence = this.getChildPresence(child)
                this.$request.put('/presence/' + presence.id, {}
                ).then((response) => {
                    if (response.data && response.data.id) {
                        this.setChildPresent(child, response.data)
                        this.setTotalChildrenPresent()
                    }
                })
            } else if (this.getChildIsPresent(child) === false) {
                // becomes true
                const currentGroupId = this.getCurrentGroup(child)
                if (currentGroupId === null) {
                    alert('Kon de groep van het kind niet bepalen')
                }
                this.$request.post('/presence', {
                    child_id: child.id,
                    group_id: currentGroupId
                }).then((response) => {
                    if (response.data && response.data.id) {
                        this.setChildPresent(child, response.data)
                        this.setTotalChildrenPresent()
                    }
                })
            }
        },
        selectChild(child) {
            var id = null
            if (child.id_child) {
                id = child.id_child
            }
            if (child.id) {
                id = child.id_child = child.id
            }
            if (id !== null) {
                this.$store.commit('SET_SELECTED_CHILD', this.getChild(id))
            }
        },
        illChanged(event) {
            this.appendChildrenById([event.idChild])
        }
    }
}
</script>

<style scoped>
a {
    color: #666;
}

.badge {
    min-width: 20px;
    font-size: 12px;
    line-height: 11px;
    vertical-align: top;
    margin-top: 2px;
    padding-top: 6px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 7px;
    border-radius: 16px;
    background: #bcc6d3;
}

.btn-link {
    color: #666;
    text-decoration: none;
}

.bg-succes {
    background: rgb(72, 200, 141) !important;
}

.bg-danger {
    background: rgb(255, 89, 79) !important
}
</style>
